export default function Policy() {
    const sections = [
        {
            id: 'privacy',
            title: 'Privacy Policy',
            body: [
                'We collect only the information required to fulfil your enquiry or order — including name, phone, email and shipping address.',
                'Your data is used solely to communicate about your order, coordinate manufacturing and dispatch, and (if you opt in) share offers.',
                'We do not sell or share your personal information with third parties, except payment processors and logistics partners strictly for order fulfilment.',
            ],
        },
        {
            id: 'terms',
            title: 'Terms of Service',
            body: [
                'All prices displayed are indicative and subject to GST, transport and hardware charges unless explicitly stated as inclusive.',
                'Lead time for manufacturing typically ranges from 7 to 21 working days after design freeze and advance payment.',
                'Colour and finish may vary marginally from digital renders due to laminate batch variations.',
            ],
        },
        {
            id: 'cancellation',
            title: 'Cancellation & Refund Policy',
            body: [
                'You may cancel an online order within 24 hours of placing it for a full refund of the online advance amount.',
                'After 24 hours from order placement, orders can NOT be cancelled and no refunds will be processed.',
                'Refunds, where applicable, are credited to the original payment method within 7–10 working days.',
            ],
        },
        {
            id: 'shipping',
            title: 'Shipping & Installation',
            body: [
                'We dispatch pan-India via insured transporters. Transportation charges are quoted upfront and depend on destination.',
                'Installation is not included in module prices. We can recommend installation partners on request.',
            ],
        },
    ];

    return (
        <div className="min-h-screen">
            <section className="bg-white border-b border-slate-200">
                <div className="kanbr-container py-20">
                    <div className="eyebrow mb-4">Legal & Policies</div>
                    <h1 className="font-display text-5xl md:text-6xl font-bold text-slate-900 leading-tight">Our policies at a glance.</h1>
                </div>
            </section>

            <section className="kanbr-container py-16 grid grid-cols-1 lg:grid-cols-4 gap-10">
                <nav className="lg:col-span-1 lg:sticky lg:top-24 h-fit space-y-3 text-sm">
                    {sections.map((s) => (
                        <a key={s.id} href={`#${s.id}`} data-testid={`policy-nav-${s.id}`} className="block text-slate-600 hover:text-blue-900">{s.title}</a>
                    ))}
                </nav>

                <div className="lg:col-span-3 space-y-14">
                    {sections.map((s) => (
                        <article key={s.id} id={s.id} data-testid={`policy-section-${s.id}`} className="border-t border-slate-200 pt-10 first:border-0 first:pt-0">
                            <h2 className="font-display text-3xl font-bold text-slate-900 mb-6">{s.title}</h2>
                            <div className="space-y-4 text-slate-700 leading-relaxed">
                                {s.body.map((p, i) => <p key={i}>{p}</p>)}
                            </div>
                        </article>
                    ))}
                </div>
            </section>
        </div>
    );
}
